import { globalOptions } from 'SRC/core/constants'
import { NotificationsListApi } from '../../api'
import { setNotifications } from '../setNotifications'
import { setLoading } from '../setLoading'

export const fetchNotifications = ({ userId, token }) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoading(true))
      const api = new NotificationsListApi()

      const response = await api.getNotifications({ userId, token })

      dispatch(setNotifications(response.notifications))

      dispatch(setLoading(false))
    } catch (e) {
      dispatch(setNotifications([]))
      dispatch(setLoading(false))
    }
  }
}
